export default __webpack_public_path__ + "static/dirk-kempthorne-042bac4bad46a27267c7e762f467b781.jpg";